import React, { useContext } from 'react';
import AppContext from '../context/Context';
import AreasRoutes from '../routes/AreasRoutes';

const AreasLayout = ( ) => {
    const { isFluid } = useContext(AppContext);

    return  <div className={isFluid ? 'container-fluid' : 'container'}>
                <AreasRoutes />
            </div>
}

export default AreasLayout;